import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Routing from './routes/Routing';
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/react-query.ts';
import { useSentryUser } from '@/hooks/useSentryUser';

const App = () => {
  useSentryUser();

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <CssBaseline />
        <Routing />
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
